import { render, staticRenderFns } from "./HoldingSelect.vue?vue&type=template&id=93bf97f6"
import script from "./HoldingSelect.vue?vue&type=script&lang=js"
export * from "./HoldingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports